import React, { createContext, useContext, useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { LeftNav } from "@/components/app/LeftNav";
import { MobileNav, MobileTopBar } from "@/components/app/MobileNav";
import { CreateModal } from "@/components/app/CreateModal";
import { VerifyBanner } from "@/components/auth/VerifyBanner";
import { AuraBurstLayer } from "@/components/brand/AuraBurst";
import { WhatsNew } from "@/components/app/WhatsNew";
import { useAuth } from "@/context/AuthContext";

const CreateCtx = createContext(() => {});
export const useCreate = () => useContext(CreateCtx);

export default function AppLayout({ children }) {
  const [createOpen, setCreateOpen] = useState(false);
  const open = () => setCreateOpen(true);
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Brand-new accounts (incl. Google signups) finish onboarding before using the app.
  useEffect(() => {
    if (user && user.onboarding_complete === false && location.pathname !== "/join") navigate("/join", { replace: true });
  }, [user, location.pathname, navigate]);

  return (
    <CreateCtx.Provider value={open}>
      <div className="flex min-h-screen bg-am-bg">
        <LeftNav onCreate={open} />
        <main className="min-w-0 flex-1 pb-16 md:pb-0">
          <MobileTopBar />
          <VerifyBanner />
          {children || <Outlet />}
        </main>
      </div>
      <MobileNav onCreate={open} />
      <CreateModal open={createOpen} onClose={() => setCreateOpen(false)} />
      <AuraBurstLayer />
      <WhatsNew />
    </CreateCtx.Provider>
  );
}
